import { useCallback, useMemo } from 'react';
import find from 'lodash/find';
import { useHistory, useParams } from 'react-router-dom';

export interface TabData {
  label: React.ReactNode;
  slug: string;
}

export interface TabPage {
  page: React.ReactNode;
  tab: TabData;
}

interface TabPagesHookInput {
  basePath?: string;
  pages: TabPage[];
  slugParam?: string;
}

export interface TabPagesHookOutput {
  tabs: TabData[];
  activePage?: TabPage;

  onGoToTab: (tabSlug: string) => void;
}

export default function useTabPages(input: TabPagesHookInput): TabPagesHookOutput {
  const { basePath = '', pages, slugParam = 'tab' } = input;
  const history = useHistory();
  const params = useParams() as any;
  const tabSlug = params[slugParam] as string;

  const tabs = useMemo((): TabData[] => pages.map((p) => p.tab), [pages]);

  const activePage = useMemo(() => find(pages, (p) => p.tab.slug === tabSlug), [pages, tabSlug]);

  const onGoToTab = useCallback(
    (tabSlug: string) => {
      history.push(`${basePath}${tabSlug}`);
    },
    [history, basePath]
  );

  return {
    tabs,
    activePage,
    onGoToTab,
  };
}
